(function(){
  'use strict';
  const drawer=document.getElementById('nt-cart-drawer');
  if(!drawer||typeof drawer.showModal!=='function')return;
  const status=drawer.querySelector('.nt-cart-status');
  let opener=null,busy=false,version=0,oldOverflow='',refreshTimer,pendingRefresh=null,lastSync=Date.now(),dirty=false;
  const root=drawer.dataset.rootUrl;
  function message(text){status.textContent=text||'';}
  function lock(on){if(on&&!busy)version++;busy=on;drawer.setAttribute('aria-busy',String(on));drawer.querySelectorAll('[data-quantity],button[name="checkout"]').forEach(b=>b.disabled=on);}
  function badge(count){document.querySelectorAll('[data-nt-cart-count]').forEach(e=>{e.textContent=count>99?'99+':String(count);e.classList.toggle('is-empty',!count);});}
  function render(html){
    const doc=new DOMParser().parseFromString(html,'text/html');
    const next=doc.querySelector('[data-cart-content]');
    if(!next)throw new Error(drawer.dataset.error);
    drawer.querySelector('[data-cart-content]').replaceWith(next);
    badge(Number(next.dataset.count)||0);
    lastSync=Date.now();dirty=false;
    lock(busy);
  }
  function refresh(){
    if(pendingRefresh)return pendingRefresh;
    const revision=++version;
    pendingRefresh=(async()=>{
      const response=await fetch(root+'?section_id=nt-cart-drawer',{headers:{Accept:'text/html'},cache:'no-store'});
      if(!response.ok)throw new Error(drawer.dataset.error);
      const html=await response.text();
      if(revision===version)render(html);
    })().finally(()=>{pendingRefresh=null;});
    return pendingRefresh;
  }
  function backgroundRefresh(){
    if(busy){clearTimeout(refreshTimer);refreshTimer=setTimeout(backgroundRefresh,250);return;}
    refresh().catch(()=>{dirty=true;});
  }
  function open(trigger){
    if(!drawer.open){opener=trigger||document.activeElement;oldOverflow=document.documentElement.style.overflow;document.documentElement.style.overflow='hidden';drawer.showModal();}
    if(!busy)message('');
    if(dirty||Date.now()-lastSync>15000)backgroundRefresh();
  }
  function close(){drawer.close();}
  drawer.addEventListener('close',()=>{document.documentElement.style.overflow=oldOverflow;if(opener&&opener.isConnected)opener.focus({preventScroll:true});});
  drawer.addEventListener('click',e=>{if(e.target.closest('[data-cart-close]'))close();else if(e.target===drawer){const r=drawer.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right)close();}});
  document.addEventListener('click',e=>{
    if(e.defaultPrevented||e.button||e.metaKey||e.ctrlKey||e.shiftKey||e.altKey)return;
    const link=e.target.closest('a[href]');if(!link)return;
    const url=new URL(link.href,location.href);
    if(url.origin===location.origin&&url.pathname.replace(/\/$/,'')===drawer.dataset.cartUrl.replace(/\/$/,'')&&!url.search){e.preventDefault();open(link);}
  });
  async function request(url,body){
    body.set('sections','nt-cart-drawer');
    body.set('sections_url',location.pathname);
    const response=await previousFetch(url+'.js',{method:'POST',headers:{Accept:'application/json'},body});
    let result;try{result=await response.json();}catch(e){throw new Error(drawer.dataset.error);}
    if(!response.ok||result.status)throw new Error(result.description||result.message||drawer.dataset.error);
    version++;
    if(result.sections&&result.sections['nt-cart-drawer'])render(result.sections['nt-cart-drawer']);
    else {if(pendingRefresh)await pendingRefresh.catch(()=>{});await refresh();}
    return result;
  }
  function settle(){
    clearTimeout(refreshTimer);
    refreshTimer=setTimeout(backgroundRefresh,1200);
  }
  document.addEventListener('submit',async e=>{
    const form=e.target;
    if(!(form instanceof HTMLFormElement))return;
    const path=new URL(form.action,location.href).pathname.replace(/\.js$/,'');
    if(path!==drawer.dataset.addUrl)return;
    e.preventDefault();e.stopImmediatePropagation();
    if(busy)return;
    const trigger=e.submitter||document.activeElement;
    const data=new FormData(form);
    const selected=form.closest('.ntps')?.querySelector('.ntps-plan[aria-current="true"]');
    if(trigger&&trigger.dataset.variant){data.set('id',trigger.dataset.variant);data.delete('selling_plan');if(trigger.dataset.plan)data.set('selling_plan',trigger.dataset.plan);}
    else if(selected){data.set('id',selected.dataset.variant);data.delete('selling_plan');if(selected.dataset.sellingPlan)data.set('selling_plan',selected.dataset.sellingPlan);}
    data.delete('return_to');data.delete('checkout');
    if(!data.get('quantity'))data.set('quantity','1');
    const buttons=[...document.querySelectorAll('button[type="submit"]')].filter(b=>b.form===form&&!b.disabled);
    lock(true);buttons.forEach(b=>b.disabled=true);
    if(!drawer.open){opener=trigger;oldOverflow=document.documentElement.style.overflow;document.documentElement.style.overflow='hidden';drawer.showModal();}
    message(drawer.dataset.loading);
    try{await request(drawer.dataset.addUrl,data);message('');}
    catch(error){message(error.message||drawer.dataset.error);await refresh().catch(()=>{});}
    finally{lock(false);buttons.forEach(b=>b.disabled=false);settle();}
  },true);
  drawer.addEventListener('click',async e=>{
    const button=e.target.closest('[data-quantity]');if(!button||busy)return;
    const item=button.closest('[data-key]');const label=button.getAttribute('aria-label');
    const body=new FormData();body.set('id',item.dataset.key);body.set('quantity',button.dataset.quantity);
    lock(true);message(drawer.dataset.loading);
    try{await request(drawer.dataset.changeUrl,body);message('');}
    catch(error){message(error.message||drawer.dataset.error);await refresh().catch(()=>{});}
    finally{lock(false);const next=label?[...drawer.querySelectorAll('[aria-label]')].find(el=>el.getAttribute('aria-label')===label):null;(next||drawer.querySelector('[data-cart-close]')).focus({preventScroll:true});settle();}
  });
  const previousFetch=window.fetch;
  window.fetch=function(){
    const result=previousFetch.apply(this,arguments);
    const input=arguments[0];const url=String(input&&input.url||input||'');
    if(/\/cart\/(add|change|update|clear)(\.js)?(?:\?|$)/.test(url))result.then(response=>{if(response.ok){dirty=true;version++;clearTimeout(refreshTimer);refreshTimer=setTimeout(backgroundRefresh,250);}},()=>{});
    return result;
  };
  ['cart:updated','cart:refresh','nt:cart:updated'].forEach(name=>document.addEventListener(name,()=>{dirty=true;clearTimeout(refreshTimer);refreshTimer=setTimeout(backgroundRefresh,250);}));
  window.addEventListener('pageshow',e=>{if(e.persisted){dirty=true;backgroundRefresh();}});
  document.addEventListener('visibilitychange',()=>{if(!document.hidden&&Date.now()-lastSync>15000)backgroundRefresh();});
  document.querySelectorAll('[data-nt-cart]').forEach(link=>{['pointerenter','focus'].forEach(name=>link.addEventListener(name,()=>{if(dirty||Date.now()-lastSync>15000)backgroundRefresh();}));});
})();

